/**
 * Extracts important objects from world data
 * Important objects are those marked with important: true
 * 
 * @param {Object} worldObject - The world object with characters, places, things arrays
 * @returns {Array} Array of important objects with _objectType field added
 */
export function getImportantObjects(worldObject) {
  if (!worldObject || typeof worldObject !== 'object') {
    return [];
  }

  const result = [];
  const chars = Array.isArray(worldObject.characters) ? worldObject.characters : [];
  const places = Array.isArray(worldObject.places) ? worldObject.places : [];
  const things = Array.isArray(worldObject.things) ? worldObject.things : [];

  chars.forEach((c) => {
    if (c?.important === true) {
      result.push({ ...c, _objectType: 'character' });
    }
  });

  places.forEach((p) => {
    if (p?.important === true) {
      result.push({ ...p, _objectType: 'place' });
    }
  });

  things.forEach((t) => {
    if (t?.important === true) {
      result.push({ ...t, _objectType: 'thing' });
    }
  });

  return result;
}
